import React from 'react';
import RibbonButton from './RibbonButton';
import RibbonButtonGroup from './RibbonButtonGroup';
import RibbonMenuGroup from './Custom/RibbonMenuGroup';
import RibbonPageGroup from './Custom/RibbonPageGroup';
import RibbonStampGroup from './Custom/RibbonStampGroup';
import RibbonVerticalDivider from './RibbonVerticalDivider';
import styles from './RibbonGroup.module.scss';
import { GlobalVariables } from '../../../pdf/GlobalVariables';
import CustomButtonGroupController from '../../Commands/CustomButtonGroupController';
import { generateUniqueKey } from '../../../utils';

interface IRibbonGroupProps {
    // TODO: Data Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    buttons: any[];
    customKey: string;
}

export default (props: IRibbonGroupProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const btns = props.buttons
        .filter(x => x !== undefined)
        .map((x: any, i: number) => {
            if (Array.isArray(x)) {
                if (
                    x.length == 2 &&
                    typeof x[0] === 'object' &&
                    !Array.isArray(x[0]) &&
                    Array.isArray(x[1])
                ) {
                    return (
                        <RibbonMenuGroup
                            key={generateUniqueKey('rbnGroup-rbnMenuGroup', i)}
                            button={x[0]}
                            menu={x[1]}
                        />
                    );
                }
                const q = x.map(y=> Array.isArray(y));
                if (q.length < 2) {
                    return <>Error</>;
                }
                if (q.reduce((a, b) => a && b) === true) {
                    // Array of RibbonMenuGroups
                    x = x.map((y, j) => (
                        <RibbonMenuGroup
                            className={styles.fillWidth}
                            key={generateUniqueKey('rbnGroup-btnGroup', i, j)}
                            button={y[0]}
                            menu={y[1]}
                        />
                    ));
                }
                return (
                    <RibbonButtonGroup
                        key={generateUniqueKey('rbnGroup-rbnBtnGroup', i)}
                        buttons={x}
                    />
                );
            }
            if (x.config && x.config.Key === GlobalVariables.StampSelectorID) {
                return (
                    <RibbonStampGroup
                        key={generateUniqueKey('rbnGroup-rbnStampGroup', i)}
                        config={x.config}
                        size={x.size}
                    />
                );
            }
            if (x.config instanceof CustomButtonGroupController) {
                switch (x.config.Key) {
                    case 'pages': return <RibbonPageGroup key={x.config.Key} config={x.config} size={x.size}/>;
                    // ToDO: case 'unitScale': return <RibbonRatioGroup key={x.config.Key} config={x.config} size={x.size}/>;
                }
            }
            return (
                <RibbonButton
                    key={generateUniqueKey('rbnGroup-rbnBtn', i)}
                    config={x.config}
                    size={x.size}
                />
            );
        });

    return (
        <>
            <div key={props.customKey} className={styles.group}>
                {btns}
            </div>
            <RibbonVerticalDivider />
        </>
    );
};
